
<script>
import AppFooter from '@/components/views/appFooter/Index.vue'
import AppHeader from '@/components/views/appHeader/Index.vue'

export default {
  name: 'app',
  components: {
    AppFooter,
    AppHeader
  },
}
</script>
<template>
  <div id="app">
    <app-header
      v-if="!$route.meta.hideNavigation"
    />
    <div
      class="app-main"
    >
      <div
        class="app-content"
        :class="{
          'app-content--fullwidth': $route.meta.noContainer || $route.meta.hideNavigation
        }"
      >
        <router-view
          :key="$route.path"
        />
      </div>
    </div>
    <app-footer
      v-if="!$route.meta.hideNavigation"
    />
  </div>
</template>
<style lang="scss">
  @import "~bulma/sass/utilities/_all";

  $primary: $orange;
  $primary-invert: findColorInvert($primary);

  $colors: (
      "white": ($white, $black),
      "black": ($black, $white),
      "light": ($light, $light-invert),
      "dark": ($dark, $dark-invert),
      "primary": ($primary, $primary-invert),
      "info": ($info, $info-invert),
      "success": ($success, $success-invert),
      "warning": ($warning, $warning-invert),
      "danger": ($danger, $danger-invert)
  );

  $snackbar-background-color: #fff;
  $snackbar-color: $black;
  $snackbar-border-radius: 4px;
  $snackbar-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.25);

  @import "~bulma";
  @import "~buefy/src/scss/buefy";
</style>